import {Routes} from '@angular/router';

export const routes: Routes = [
  { path: '', loadComponent: () => import('./components/properties/properties.component').then(m => m.PropertiesComponent) },
  {
    path: ':propertyId',
    title: 'Property Details',
    loadComponent: () => import('./components/property/property.component').then(m => m.PropertyComponent)
  },
];
